import React, { useState } from "react"

import T from "prop-types"

import { useIconOverrides, useMenuOverrides } from "./css"
import { LabeledCheckbox, Menu } from "../../atoms"

export const FilterMenu = ({ filterOptions, maxHeight, menuGap, onClick }) => {
  const [anchorElement, setAnchorElement] = useState(null)
  const [options, setOptions] = useState(filterOptions)
  const open = Boolean(anchorElement)

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorElement(null)
  }

  const handleOptionClick = (option) => {
    const newOptions = [...options]
    const index = newOptions.findIndex((opt) => opt.value === option.value)

    newOptions[index].checked = !newOptions[index].checked
    setOptions([...newOptions])
    onClick(newOptions)
  }

  const isFilterUsed = options.filter((filter) => filter.checked).length > 0

  return (
    <React.Fragment>
      {/* TODO: change icon to MuiIcon.FilterAlt after migration */}
      <i
        className={`icon ${isFilterUsed ? "icon-filter3" : "icon-filter4"} ${
          useIconOverrides().filterIcon
        }`}
        onClick={handleClick}
      />
      <Menu.Root
        anchorEl={anchorElement}
        open={open}
        onClose={handleClose}
        classes={useMenuOverrides({ maxHeight, menuGap })}>
        {options.map((option) => (
          <Menu.Item key={option.value} padding="0.35rem 1.2rem">
            <LabeledCheckbox
              label={option.title}
              checked={option.checked}
              onClick={(event) => {
                event.stopPropagation()
                handleOptionClick(option)
              }}
            />
          </Menu.Item>
        ))}
      </Menu.Root>
    </React.Fragment>
  )
}

FilterMenu.propTypes = {
  filterOptions: T.arrayOf(
    T.shape({ checked: T.bool, title: T.string.isRequired, value: T.string.isRequired }),
  ),
  maxHeight: T.oneOfType([T.number, T.string]),
  menuGap: T.oneOfType([T.number, T.string]),
  onClick: T.func,
}
